export default __webpack_public_path__ + "assets/images/f8753f9b67071b464f05a3e2697159a9.png";